import { Image } from 'react-bootstrap';
import icStar from '../../../assets/img/ic-star.svg';
import icStarGray from '../../../assets/img/ic-star-gray.svg';

// Extracted from the existing desktop rating markup so mobile and desktop
// never drift on how a rating is rendered.
const StarRating = ({ rating }) => {
    const value = Number(rating) || 0;

    return (
        <span className="rating">
            {Array.from({ length: 5 }).map((_, index) => (
                <Image
                    key={index}
                    className="rating-star"
                    src={index < value ? icStar : icStarGray}
                    alt=""
                />
            ))}
            <span className="rating-text">({value} star)</span>
        </span>
    );
};

export default StarRating;
